export function getBraintreeClientToken(customerId=null, storeCode ) {
    const endpoint = customerId ? `/${storeCode}/V1/papi/token/${customerId}` : `/${storeCode}/V1/papi/token`;
    const options = {
        method: 'GET'
    };

    return [endpoint, options];
}


export function getScalaPayRedirect(sessionOrCartId, storeCode){

    const endpoint =`/${storeCode}/V1/scalapay/redirect/${sessionOrCartId ? ( sessionOrCartId.accessToken ? 'customer/mine' : sessionOrCartId) : 'none'}`;
    const options = {
        method: 'GET'
    };

    if (sessionOrCartId.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};

    return [endpoint, options];
}

export function getScalaPayConfirm(sessionOrCartId,orderToken, storeCode){

    const endpoint =`/${storeCode}/V1/scalapay/${sessionOrCartId && sessionOrCartId?.accessToken ? 'me/' : ''}confirm?orderToken=${orderToken}`;
    const options = {
        method: 'GET'
    };

    if (sessionOrCartId?.accessToken) options.headers = {'Authorization': 'Bearer ' + sessionOrCartId.accessToken};


    return [endpoint, options];
}


export function getOrderDetails(orderIncrementId, protectCode, storeCode){

    const endpoint =`/${storeCode}/V1/xapi/order/details/${orderIncrementId}/${protectCode}`;

    const options = {
        method: 'GET'
    };

    return [endpoint, options];

}


export function getRePayPaymentMethods(orderIncrementId, protectCode, storeCode){

    const endpoint =`/${storeCode}/V1/repay/list/${orderIncrementId}/${protectCode}`;

    const options = {
        method: 'GET'
    };

    return [endpoint, options];

}


export function changePaymentMethod(orderIncrementId, protectCode, paymentMethod, additionalData, storeCode){

    const endpoint =`/${storeCode}/V1/repay/change/${orderIncrementId}/${protectCode}`;

    const options = {
        method: 'POST',
        data: {
            paymentMethod: {
                method: paymentMethod,
                additional_data: additionalData
            },
        }
    };

    return [endpoint, options];

}



export function checkVat(vatNumber, countryCode, storeCode) {

    const endpoint = `/${storeCode}/V1/abill/vat/check/${countryCode}/${vatNumber}`;

    const options = {
        method: 'GET'
    };

    return [endpoint, options];

}


export function generateOtpRequest(phoneNumber, storeCode) {

    const endpoint = `/${storeCode}/V1/sfmessage/otp/${phoneNumber}`;

    const options = {
        method: 'GET'
    };

    return [endpoint, options];

}

export function checkOtpRequest(phoneNumber, code, storeCode) {

    const endpoint = `/${storeCode}/V1/sfmessage/otp/check/${phoneNumber}/${code}`;

    const options = {
        method: 'GET'
    };

    return [endpoint, options];

}

export function checkShippingAddress(address, storeCode){

    const endpoint = `/${storeCode}/V1/gls/checkAddress`;

        const options = {
            method: 'POST',
            data: {
                address: address
            }
        };

        return [endpoint, options];
}